import React, { useState, useEffect, useRef } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  colors,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { GoSearch } from "react-icons/go";
import DeleteModal from "../../Components/DeleteModal";
import { TbFilterSearch } from "react-icons/tb";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { IoSearchOutline } from "react-icons/io5";
import { MdDeleteOutline } from "react-icons/md";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { axiosInstance } from "../../axiosInstance";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const columns = [
  { id: "username", label: "USERNAME", minWidth: 170, align: "center" },
  { id: "name", label: "NAME", minWidth: 170, align: "center" },
  {
    id: "business_name",
    label: "BUSINESS NAME",
    minWidth: 170,
    align: "center",
  },
  {
    id: "business_type",
    label: "BUSINESS TYPE",
    minWidth: 170,
    align: "center",
  },
  { id: "email", label: "EMAIL", minWidth: 170, align: "center" },
  { id: "mobile_no", label: "PHONE NUMBER", minWidth: 170, align: "center" },
  { id: "status", label: "STATUS", minWidth: 170, align: "center" },
  // {
  //   id: "is_registered",
  //   label: "Is Registered",
  //   minWidth: 170,
  //   align: "center",
  // },
  // { id: "is_active", label: "Is Active", minWidth: 170, align: "center" },
  // { id: "is_verified", label: "Is Verified", minWidth: 170, align: "center" },
  // { id: "status", label: "STATUS", minWidth: 100, align: "center" },
  // { id: "approval", label: "APPROVAL", minWidth: 170, align: "center" },
  // { id: "actions", label: "ACTIONS", minWidth: 100, align: "center" },
];

function createData(
  username,
  business_name,
  mobile_no,
  email,
  is_registered,
  is_active,
  is_verified,
) {
  return {
    username,
    business_name,
    mobile_no,
    email,
    is_registered,
    is_active,
    is_verified,
  };
}

export function ListRetailer() {
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedIdToDelete, setSelectedIdToDelete] = useState(null);

  const [retailerList, setRetailerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedRetailerId, setSelectedRetailerId] = useState(null);
  const [toggleModalOpen, setToggleModalOpen] = useState(false);
  const [toggleTarget, setToggleTarget] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();

  const location = useLocation();

  const getSavedFilters = () => {
    return JSON.parse(localStorage.getItem(FILTER_STORAGE_KEY));
  };
  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(20);

  //  const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  // const fetchRetailers = async () => {
  //   setLoading(true);
  //   setError("");
  //   try {
  //     const res = await axiosInstance.get("/admin/retailer-list/");
  //     console.log("✅ Retailer list response:", res.data);
  //     if (res.data.status === "success") {
  //       setRetailerList(res.data.data || []);
  //     } else {
  //       setError("Failed to fetch Retailer data.");
  //     }
  //   } catch (err) {
  //     console.error("❌ Error fetching Retailer data:", err);
  //     setError("Something went wrong. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchRetailers = async () => {
    setLoading(true);
    setError("");

    try {
      const savedFilters = getSavedFilters();

      let res;

      // ✅ IF FILTERS EXIST → POST API
      if (savedFilters && (savedFilters.state || savedFilters.city)) {
        const body = {
          state: savedFilters.state || "",
          city: savedFilters.city || "",
        };

        res = await axiosInstance.post("/admin/retailer-list/", body);
      }
      // ❌ NO FILTERS → NORMAL GET API
      else {
        res = await axiosInstance.get("/admin/retailer-list/");
      }

      if (res.data.status === "success") {
        setRetailerList(res.data.data || []);
      } else {
        setError("Failed to fetch Retailer data.");
      }
    } catch (err) {
      console.error("❌ Error fetching Retailer data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRetailers();
  }, []);

  const handleDelete = async () => {
    try {
      const res = await axiosInstance.delete(
        `/admin/retailer-list/${selectedRetailerId}/`,
      );
      if (res.data.status === "success") {
        toast.success("Retailer deleted successfully");
        fetchRetailers();
      } else {
        toast.error(res.data.message || "Delete failed");
      }
    } catch (err) {
      toast.error("Error deleting Retailer");
    } finally {
      setDeleteModalOpen(false);
    }
  };

  const handleToggleStatus = async () => {
    try {
      const res = await axiosInstance.patch(
        `/admin/retailer-list/${toggleTarget.id}/`,
        {
          is_active: !toggleTarget.is_active,
        },
      );
      if (res.data.status === "success") {
        toast.success("Status updated successfully");
        fetchRetailers();
        setToggleModalOpen(false);
      } else {
        toast.error("Failed to update status");
      }
    } catch (err) {
      toast.error("Error updating status");
    }
  };

  const handleDropdownChange = async (rowId, field, newValue) => {
    const patchData = { [field]: newValue === "Yes" };

    try {
      const res = await axiosInstance.patch(
        `/admin/retailer-list/${rowId}/`,
        patchData,
      );
      if (res.data.status === "success") {
        toast.success(`${field} updated successfully`);
        fetchRetailers();
      } else {
        toast.error(`Failed to update ${field}`);
      }
    } catch (err) {
      toast.error(`Error updating ${field}`);
    }
  };

  const FILTER_STORAGE_KEY = "RETAILER_FILTERS";

  //filter modal state start here
  const [showFilter, setShowFilter] = useState(false);
  const [stateCityMap, setStateCityMap] = useState({});
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);

  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [stateSearch, setStateSearch] = useState("");
  const [citySearch, setCitySearch] = useState("");

  // Fetch state-city mapping API
  const fetchStateCityMap = async () => {
    try {
      const res = await axiosInstance.get("admin/user-state-list/");
      if (res.data.status === "success") {
        const data = res.data.data;
        setStateCityMap(data);
        setStateOptions(Object.keys(data));
      }
    } catch (err) {
      console.error("Error fetching state-city mapping:", err);
    }
  };

  useEffect(() => {
    const savedFilters = JSON.parse(localStorage.getItem(FILTER_STORAGE_KEY));

    if (savedFilters) {
      const { state, city } = savedFilters;

      setSelectedState(state || "");
      setSelectedCity(city || "");

      if (state) {
        fetchStateCityMap().then(() => {
          setCityOptions(stateCityMap[state] || []);
        });
      }

      applyFiltersWithValues(state || "", city || "");
    }
  }, []);

  // Run when modal opens
  useEffect(() => {
    if (showFilter) {
      fetchStateCityMap();
    }
  }, [showFilter]);

  // When state is selected, update city options
  const handleStateSelect = (state) => {
    if (selectedState === state) {
      setSelectedState("");
      setCityOptions([]);
      setSelectedCity("");
    } else {
      setSelectedState(state);
      setCityOptions(stateCityMap[state] || []);
      setSelectedCity("");
    }
  };

  // A utility function to apply filters with provided values
  // const applyFiltersWithValues = async (stateValue, cityValue) => {
  //   setLoading(true);
  //   setError("");

  //   try {
  //     const body = {
  //       state: stateValue,
  //       city: cityValue,
  //     };

  //     const res = await axiosInstance.post("/admin/retailer-list/", body);

  //     if (res.data.status === "success") {
  //       setRetailerList(res.data.data || []);
  //     } else {
  //       setError("Filter failed.");
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     setError("Something went wrong.");
  //   } finally {
  //     setLoading(false);
  //     setPage(0);
  //   }
  // };

  const applyFiltersWithValues = async (stateValue, cityValue) => {
    localStorage.setItem(
      FILTER_STORAGE_KEY,
      JSON.stringify({ state: stateValue, city: cityValue }),
    );

    setSelectedState(stateValue);
    setSelectedCity(cityValue);

    setPage(0);
    fetchRetailers();
  };

  // Normal apply from inside modal
  const applyFilters = async () => {
    setShowFilter(false);
    applyFiltersWithValues(selectedState, selectedCity);
  };

  // Clear all filters
  const clearAllFilters = () => {
    localStorage.removeItem(FILTER_STORAGE_KEY);
    setSelectedState("");
    setSelectedCity("");
    applyFiltersWithValues("", "");
  };

  // Remove only State
  const removeStateFilter = () => {
    const newState = "";
    const newCity = "";
    setSelectedState("");
    setSelectedCity("");
    setCityOptions([]);
    applyFiltersWithValues(newState, newCity);
  };

  // Remove only City
  const removeCityFilter = () => {
    const newCity = "";
    setSelectedCity("");
    applyFiltersWithValues(selectedState, newCity);
  };

  //filter modal state end here

  // date filter

  const [filterDate, setFilterDate] = useState(null);

  const applyDateFilters = async (selectedDate) => {
    if (!selectedDate) return; // no date selected

    setLoading(true);
    setError("");
    try {
      const body = {
        date: dayjs(selectedDate).format("DD-MM-YYYY"), // use the Dayjs object directly
      };

      const res = await axiosInstance.post("/admin/retailer-list/", body);
      if (res.data.status === "success") {
        setRetailerList(res.data.data || []);
      } else {
        setError("Filter failed.");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong.");
    } finally {
      setLoading(false);
      setPage(0);
    }
  };

  const clearDateFilters = () => {
    //clear date filters
    setFilterDate(null);
    fetchRetailers();
    // clear state and city filters
    localStorage.removeItem(FILTER_STORAGE_KEY);
    setSelectedState("");
    setSelectedCity("");
    applyFiltersWithValues("", "");
  };

  useEffect(() => {
    fetchRetailers();
  }, []);

  const options = [
    { value: "Approved", label: "Approved", color: "#34C759" },
    { value: "Rejected", label: "Rejected", color: "#FF3B30" },
    { value: "Pending", label: "Pending", color: "#4184D1" },
  ];
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#4184D1", // Change placeholder text color
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#4184D1", // Change dropdown arrow color
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#E7F0F9" : "white", // Change background on hover
      color: state.data.color, //apply unique for each option
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.data.color, // Apply the selected option's color
    }),
    indicatorSeparator: () => ({
      display: "none", // Removes the right-side border
    }),
  };

  useEffect(() => {
    if (location.pathname === "/manage-retailer") {
      localStorage.removeItem("retailer_username");
      localStorage.removeItem("retailer_ID");
      localStorage.removeItem("retailer_User_ID");
    }
  }, [location]);

  const getFullName = (row) =>
    `${row.first_name || "-"} ${row.last_name || "-"}`.toLowerCase();

  // const filteredData = retailerList.filter((row) =>
  //   getFullName(row).includes(searchQuery.toLowerCase())
  // );

  const filteredData = retailerList.filter((row) => {
    const query = searchQuery.toLowerCase();
    return (
      getFullName(row).toLowerCase().includes(query) ||
      row.mobile_no?.toLowerCase().includes(query) ||
      row.email?.toLowerCase().includes(query) ||
      row.username?.toLowerCase().includes(query) ||
      row.retailers?.business_name?.toLowerCase().includes(query)
    );
  });

  // save table page size in local to save data on page change
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem("retailer_page");
    return savedPage ? Number(savedPage) : 0;
  });

  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const savedRows = localStorage.getItem("retailer_rowsPerPage");
    return savedRows ? Number(savedRows) : 20;
  });
  const pageChangedByUser = useRef(false);

  const handleChangePage = (event, newPage) => {
    pageChangedByUser.current = true;
    setPage(newPage);
    localStorage.setItem("retailer_page", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const value = Number(event.target.value);
    pageChangedByUser.current = true;

    setRowsPerPage(value);
    setPage(0);

    localStorage.setItem("retailer_rowsPerPage", value);
    localStorage.setItem("retailer_page", 0);
  };

  // Reset page on search and filters

  useEffect(() => {
    if (loading) return;

    // Do NOT reset page on refresh
    if (!pageChangedByUser.current) return;

    const maxPage = Math.max(
      0,
      Math.ceil(filteredData.length / rowsPerPage) - 1,
    );

    if (page > maxPage) {
      setPage(0);
      localStorage.setItem("retailer_page", 0);
    }
  }, [filteredData.length, rowsPerPage, loading, page]);

  return (
    <>
      <div>
        <div className="admin-top-container">
          <div className="admin-listText">List of Retailer</div>
          {/* <div>
            <select
              className="listAdmin-showRecords"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
            >
              <option value={20}>Show No of Records</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
              <option value={1000}>1000</option>
              <option value={2000}>2000</option>
              <option value={5000}>5000</option>
            </select>
          </div> */}
          <div>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Select Date"
                format="DD-MM-YYYY"
                value={filterDate}
                maxDate={dayjs()}
                onChange={(newValue) => {
                  setFilterDate(newValue);
                  applyDateFilters(newValue);
                }}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: {
                      "& .MuiOutlinedInput-root": {
                        height: 35,
                        width: 180,
                        "& fieldset": {
                          border: "1px solid #b8b9b9", // custom border
                        },
                        "&:hover fieldset": {
                          border: "1px solid #b8b9b9", // hover border
                        },
                        "&.Mui-focused fieldset": {
                          border: "1px solid #b8b9b9", // focus border
                        },
                      },
                      "& .MuiInputLabel-root": {
                        color: "black", // label color
                        fontSize: "0.85rem",
                      },
                      "& .MuiInputBase-input": {
                        padding: "4px 8px", // adjust padding
                        fontSize: "0.85rem",
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </div>
          <div className="search-container">
            <div className="nav-search ">
              <span className="search-icons">
                <GoSearch />
              </span>
              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
          <div className="btnFilter">
            <button onClick={() => setShowFilter(true)}>
              <TbFilterSearch /> Filter
            </button>
          </div>
        </div>
        {/* filter modal  */}
        <Modal
          show={showFilter}
          onHide={() => setShowFilter(false)}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Filter</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="filterGrid">
              {/* State Filter */}
              <div className="filterState">
                <div className="filterTitle">Filter by State</div>
                <div className="searchContainer">
                  <IoSearchOutline className="searchIcon" />
                  <input
                    type="text"
                    placeholder="Search any state"
                    value={stateSearch}
                    onChange={(e) => setStateSearch(e.target.value)}
                  />
                </div>
                {stateOptions
                  .filter((s) =>
                    s.toLowerCase().includes(stateSearch.toLowerCase()),
                  )
                  .map((state) => (
                    <div className="stateList" key={state}>
                      <input
                        type="checkbox"
                        checked={selectedState === state}
                        onChange={() => handleStateSelect(state)}
                      />
                      <span>{state}</span>
                    </div>
                  ))}
              </div>

              {/* City Filter */}
              {selectedState && (
                <div className="filterCity">
                  <div className="filterTitle">Filter by City</div>
                  <div className="searchContainer">
                    <IoSearchOutline className="searchIcon" />
                    <input
                      type="text"
                      placeholder="Search any City"
                      value={citySearch}
                      onChange={(e) => setCitySearch(e.target.value)}
                    />
                  </div>
                  {cityOptions
                    .filter((c) =>
                      c.toLowerCase().includes(citySearch.toLowerCase()),
                    )
                    .map((city) => (
                      <div className="stateList" key={city}>
                        <input
                          type="checkbox"
                          checked={selectedCity === city}
                          onChange={() =>
                            setSelectedCity(selectedCity === city ? "" : city)
                          }
                        />
                        <span>{city}</span>
                      </div>
                    ))}
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btnCancelFilter"
              onClick={() => setShowFilter(false)}
            >
              Cancel
            </Button>
            <Button className="btnApplyFilter" onClick={applyFilters}>
              Apply Filter
            </Button>
          </Modal.Footer>
        </Modal>
        {/* filtered data  */}

        {/* Selected Filters */}
        {(selectedState || selectedCity) && (
          <div>
            <div className="filteredDataText">
              <div>Filtered Results</div>
              <div onClick={clearAllFilters} style={{ cursor: "pointer" }}>
                <MdDeleteOutline />
                <span className="ps-1">Clear All</span>
              </div>
            </div>
            <div className="seletedFilter">
              {selectedState && (
                <div>
                  <span className="ps-1">{selectedState}</span>
                  <IoIosCloseCircleOutline
                    style={{ cursor: "pointer" }}
                    onClick={removeStateFilter}
                  />
                </div>
              )}
              {selectedCity && (
                <div>
                  <span className="ps-1">{selectedCity}</span>
                  <IoIosCloseCircleOutline
                    style={{ cursor: "pointer" }}
                    onClick={removeCityFilter}
                  />
                </div>
              )}
            </div>
          </div>
        )}

        <div>
          <button className="reset-btn" onClick={clearDateFilters}>
            Reset
          </button>
        </div>

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      className="table-header"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : filteredData.length > 0 ? (
                  filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const fullName = getFullName(row);
                      const isMatch = fullName.includes(
                        searchQuery.toLowerCase(),
                      );
                      return (
                        <TableRow
                          className="table-row"
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#E7F0F9" : "white",
                          }}
                        >
                          {columns.map((column) => {
                            let value = row[column.id];

                            // Special handling for "name" column to combine first and last names
                            if (column.id === "name") {
                              if (row.first_name || row.last_name) {
                                value = `${row.first_name || ""} ${
                                  row.last_name || ""
                                }`.trim();
                              } else {
                                value = "--";
                              }
                            }
                            if (column.id === "business_name") {
                              value =
                                row.retailers?.business_name ||
                                row.retailers?.clinic_name ||
                                row.retailers?.hospital_name ||
                                row.retailers?.diagnostic_name ||
                                "--";
                            }

                            if (column.id === "status") {
                              if (row.is_verified === true) {
                                value = (
                                  <span className="status-badge verified">
                                    Verified
                                  </span>
                                );
                              } else {
                                value = (
                                  <span className="status-badge pending">
                                    Pending
                                  </span>
                                );
                              }
                            }

                            if (column.id === "business_type") {
                              if (
                                row.retailers &&
                                row.retailers.business_type
                              ) {
                                value = row.retailers.business_type
                                  .replace(/_/g, " ")
                                  .replace(/\b\w/g, (char) =>
                                    char.toUpperCase(),
                                  );
                              } else {
                                value = "--";
                              }
                            }

                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                className={`${column.id}-column tableCelldata`}
                                sx={{
                                  color:
                                    column.id === "status"
                                      ? value === "Active"
                                        ? "green"
                                        : "red"
                                      : "inherit",
                                }}
                              >
                                {/* {column.id === "actions" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    <IconButton sx={{ color: "black" }}>
                                      <EditIcon
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "18px",
                                        }}
                                        onClick={() => {
                                          localStorage.setItem(
                                            "retailer_username",
                                            row.username
                                          );
                                          localStorage.setItem(
                                            "retailer_ID",
                                            row.retailers?.retailer_id || ""
                                          );
                                          localStorage.setItem(
                                            "retailer_User_ID",
                                            row.id || ""
                                          );
                                          navigate(
                                            `/manage-retailer-edit/${row.id}`
                                          );
                                        }}
                                      />
                                    </IconButton>
                                    <IconButton
                                    sx={{ color: "black" }}
                                    onClick={() => {
                                      setSelectedRetailerId(row.id);
                                      setDeleteModalOpen(true);
                                    }}
                                  >
                                    <DeleteIcon style={{ fontSize: "18px" }} />
                                  </IconButton>
                                    <div
                                      className="form-check form-switch"
                                      style={{ marginTop: "5px" }}
                                    >
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`toggleSwitch-${row.id}`}
                                        checked={row.is_active}
                                        onChange={() => {
                                          setToggleTarget(row);
                                          setToggleModalOpen(true);
                                        }}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`toggleSwitch-${row.id}`}
                                      ></label>
                                    </div>
                                  </div> */}
                                {column.id === "username" ? (
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      color: "#2563eb",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() => {
                                      localStorage.setItem(
                                        "retailer_username",
                                        row.username,
                                      );
                                      localStorage.setItem(
                                        "retailer_ID",
                                        row.retailers?.retailer_id || "",
                                      );
                                      localStorage.setItem(
                                        "retailer_User_ID",
                                        row.id || "",
                                      );
                                      navigate(
                                        `/manage-retailer-edit/${row.id}`,
                                      );
                                    }}
                                  >
                                    {row.username}
                                  </span>
                                ) : [
                                    "is_registered",
                                    "is_active",
                                    "is_verified",
                                  ].includes(column.id) ? (
                                  <select
                                    className="yesDropdown"
                                    value={row[column.id] ? "Yes" : "No"}
                                    onChange={(e) =>
                                      handleDropdownChange(
                                        row.id,
                                        column.id,
                                        e.target.value,
                                      )
                                    }
                                  >
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                  </select>
                                ) : value === null ||
                                  value === undefined ||
                                  value === "" ? (
                                  "--"
                                ) : (
                                  value
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={columns.length}
                      align="center"
                      style={{ padding: "40px 0" }}
                    >
                      No Data Available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal
        show={deleteModalOpen}
        onHide={() => setDeleteModalOpen(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="delete-confirmation-title">
            Are you sure?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p id="delete-confirmation-description">
            Do you really want to delete this Retailer? This action cannot be
            undone.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDeleteModalOpen(false)}>
            No
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Toggle Status Modal */}
      {/* Active or InActive Confirmation Modal */}

      <Modal
        show={toggleModalOpen}
        onHide={() => setToggleModalOpen(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="toggle-status-title">Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Do you want to {toggleTarget?.is_active ? "INACTIVATE" : "ACTIVATE"}{" "}
            this Retailer?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setToggleModalOpen(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleToggleStatus}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <DeleteModal
        open={deleteModal}
        onClose={() => setDeleteModal(false)}
        // onConfirm={handleDelete}
        title="Delete Wholesaler"
        message="Are you sure you want to permanently delete this wholesaler?"
      /> */}
    </>
  );
}
